import React from "react";
import { Button, Card } from "react-bootstrap";
import CashOutDollarsRequestModal from "./RateAgnosticHourUtilizationRequestModal";

export default function AvailableHoursHeader({ totals, blackedOut, consultantId, onRefresh, showEmployeeLabel, employeeName }) {
  const canRequestCashOut = totals.hoursRemaining > 0;

  return (
    <Card style={{
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      border: '1px solid #e0e0e0',
      width: '100%',
      marginBottom: '20px'
    }}>
      <Card.Body style={{ padding: '16px 20px' }}>
        {showEmployeeLabel && employeeName && (
          <div style={{ textAlign: 'left', marginBottom: '1rem' }}>
            <h5 style={{ margin: 0, fontWeight: 600 }}>{employeeName}'s Rev Share</h5>
          </div>
        )}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '40px'
        }}>
          <div style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '12px',
            padding: '24px 32px',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{
              fontSize: '14px',
              color: '#6c757d',
              marginBottom: '8px',
              fontWeight: '500',
              textAlign: 'center'
            }}>
              Requests Pending Approval
            </div>
            <div style={{
              display: 'flex',
              gap: '40px',
              justifyContent: 'center'
            }}>
              <div style={{
                fontSize: '32px',
                fontWeight: 'bold',
                color: '#212529',
                textAlign: 'center'
              }}>
                {totals.pendingHours.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                <span style={{
                  fontSize: '14px',
                  color: '#6c757d',
                  marginLeft: '4px',
                  fontWeight: '500'
                }}>
                  hrs.
                </span>
              </div>
              <div style={{
                fontSize: '32px',
                fontWeight: 'bold',
                color: '#212529',
                textAlign: 'center'
              }}>
                ${totals.pendingValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </div>
            </div>
          </div>

          <div style={{
            backgroundColor: 'transparent',
            borderRadius: '12px',
            padding: '24px 32px',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{
              fontSize: '14px',
              color: '#6c757d',
              marginBottom: '8px',
              fontWeight: '500',
              textAlign: 'center'
            }}>
              Rev Share Available
            </div>
            <div style={{
              display: 'flex',
              gap: '40px',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <div style={{
                fontSize: '32px',
                fontWeight: 'bold',
                color: '#212529',
                textAlign: 'center'
              }}>
                {totals.hoursRemaining.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                <span style={{
                  fontSize: '14px',
                  color: '#6c757d',
                  marginLeft: '4px',
                  fontWeight: '500'
                }}>
                  hrs.
                </span>
              </div>
              <div style={{
                fontSize: '32px',
                fontWeight: 'bold',
                color: '#212529',
                textAlign: 'center'
              }}>
                ${totals.dollarAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </div>
              {blackedOut ? (
                <div style={{
                  backgroundColor: '#fff3cd',
                  borderRadius: '8px',
                  padding: '12px 20px',
                  border: '1px solid #ffc107'
                }}>
                  <div style={{
                    fontSize: '14px',
                    color: '#856404',
                    fontWeight: '500'
                  }}>
                    Blackout period
                  </div>
                </div>
              ) : canRequestCashOut ? (
                <CashOutDollarsRequestModal requestableDollars={totals.dollarAmount} consultantId={consultantId} onSuccess={onRefresh} />
              ) : (
                <Button variant="primary" disabled>Request Cash Out</Button>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
